import React from 'react';

const PresetSelector = ({ presets, selectedPreset, onChange, language }) => {
  return (
    <div className="preset-selector">
      <label htmlFor="preset-select" className="preset-label">
        {language === 'KR' ? 'Canon 모드 선택:' : 'Select Canon Mode:'}
      </label>
      <select
        id="preset-select"
        value={selectedPreset}
        onChange={(e) => onChange(e.target.value)}
        className="preset-dropdown"
      >
        {presets.map((preset) => (
          <option key={preset.id} value={preset.id}>
            {preset.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default PresetSelector;